import { FC } from 'react'
import { IProgramId } from '@ucheba/store/institutions/programs/programId/types'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { LimitedList } from '@ucheba/ui/components/LimitedList/desktop'
import { useSelector } from 'react-redux'
import { authSelectors } from '@ucheba/store/auth'
import { List } from '@ucheba/ui/components/List/desktop'
import { EActivityInfoPart, EActivityTypes } from '@ucheba/utils/types/userActivityTypes'
import { getSingleQuery } from '@ucheba/utils/helpers/router'
import { useRouter } from 'next/router'
import InstitutionTeachersListItem from '../../../../../../components/InstitutionTeachers/desktop/InstitutionTeachersListItem'
import { useUserActivity } from '../../../../../../../utils/hooks/useUserActivity'
import { useGetInstitutionsId } from '../bll/useGetInstitutionsId'

const ProgramIdPageTeachers: FC<{ teachers: IProgramId['members'] }> = (props) => {
  const { teachers } = props
  const isAuth = useSelector(authSelectors.isAuth)
  const { query } = useRouter()
  const programId = query?.id

  const { setUserActivity } = useUserActivity()

  const institutionId = useGetInstitutionsId()

  const handleShowAllClick = async (): Promise<void> => {
    await setUserActivity({
      activityType: EActivityTypes.infoPartViewed,
      institutionId,
      data: { infoPart: EActivityInfoPart.teachers },
      programId: getSingleQuery(programId) as undefined | number,
    })
  }

  if (!teachers || teachers.length === 0) return null

  return (
    <>
      <Heading h3='Преподаватели' spacing='large' />

      <LimitedList
        id='teachers'
        items={teachers}
        isAuth={isAuth}
        buttonText='Показать ещё'
        limit={3}
        showMore
        onShowAll={handleShowAllClick}
      >
        {({ limitedItems }) => {
          return (
            <List>
              {limitedItems.map((teacher) => {
                const { comment, position, id, person } = teacher

                const description = `${
                  position ? `${position}${comment ? ',' : ''}` : ''
                } ${comment ? `${comment}` : ''}`

                return (
                  <InstitutionTeachersListItem
                    key={id}
                    description={description}
                    avatarThumbnailUrl={person.avatarUrl}
                    fullName={person.fullName}
                    fontSize='h4'
                    isDivider
                  />
                )
              })}
            </List>
          )
        }}
      </LimitedList>
    </>
  )
}

export default ProgramIdPageTeachers
